import { render, staticRenderFns } from "./IngredientItemImage.vue?vue&type=template&id=bb0fbc66&"
import script from "./IngredientItemImage.vue?vue&type=script&lang=js&"
export * from "./IngredientItemImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports